import React from 'react';


import FieldManagementFormProto from "../../../../fields3/proto/render/management/management-form";
// @ts-ignore
import FormError from "../../../../gd-form/common/form-error/form-error";
import FormRow from "../../../../gd-form/form/form-ui5/form-row";
// @ts-ignore
import DropdownOptionsEditor from "./management/options-editor/items-list-editor-form-element";
import {FieldManagementFormProps} from "../../../render/management-form";
import FormManager from "../../../../gd-form/common/form-manager";

export default class FieldDropdown_ManagementForm extends FieldManagementFormProto {

    constructor(props:FieldManagementFormProps) {
        super(props);

        this.initFormData.options = null;

        if (this.props.field) {
            this.initFormData.options =           _.get(this.props,'field.options', null);
        }

        this.formStructure.fields.options = {
            type        : 'select',
            isRequired  : true,
            label       : 'Options',
            validator   : (val:any) => {
                let res: string | boolean = true
                if (!val || val.length < 1) return 'Add at least one item'
                _.map(val, (i:any) => {
                    if (_.isNil(i.value) ||
                        (typeof i.value === 'string' && i.value.trim() === '')) {
                        res = 'Options items should not be empty'
                    }
                })
                return res
            }
        }

        // important to have it here !
        this.formStructure.onSubmit = this.onSubmit;

        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit = (result:any) => {
        super.onSubmit(result);

        this.props.field.options = result.options;

        // props.field is an object so we never return anything in here
        this.props.onSubmit(this.props.field, result);
    }

    renderAdditionalControls() {
        return (
            <FormRow label="Options">
                <DropdownOptionsEditor form={this.form}
                                       name="options"
                                       colorSelectionEnabled={true}
                />
                <FormError form={this.form} name="options" />
            </FormRow>
        )
    }
}
